<template>
  <div class="channel-user-page">
    <tableComponents
      ref="tableComponents"
      :pagination="{
        currentPage: paginationForm.page,
        pageSize: paginationForm.page_size,
        total,
      }"
      :sizes="[15, 20, 50, 100]"
      :searchData="userSearchData"
      :isHaveExport="false"
      :isHaveAdd="false"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @sendUserSearch="getSearch"
    >
      <template #table>
        <el-table v-if="!isMobileViewport" :data="list" border stripe v-loading="loading">
          <el-table-column prop="id" label="ID" width="70" align="center" />
          <el-table-column prop="nickname" label="昵称" min-width="140" />
          <el-table-column prop="username" label="账号" min-width="140" />
          <el-table-column label="APP" min-width="120" align="center">
            <template slot-scope="{ row }">
              {{ row.app && row.app.app_name ? row.app.app_name : "--" }}
            </template>
          </el-table-column>
          <el-table-column prop="channel_id" label="渠道ID" width="110" align="center" />
          <el-table-column label="今日广告" width="100" align="center">
            <template slot-scope="{ row }">
              {{ row.ad_list || 0 }}
            </template>
          </el-table-column>
          <el-table-column label="今日收益" min-width="140" align="center">
            <template slot-scope="{ row }">
              {{ row.ecpm_total || "--" }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="140" align="center">
            <template slot-scope="{ row }">
              <template v-if="row.banned_time && row.banned_time * 1000 > Date.now()">
                <el-tag type="danger">
                  封禁至 {{ $fnc.getTimeFormat(row.banned_time, "ymdhms") }}
                </el-tag>
              </template>
              <el-tag v-else type="success">正常</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="注册时间" min-width="160" align="center">
            <template slot-scope="{ row }">
              {{ $fnc.getTimeFormat(row.created_time, "ymdhms") }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            :width="isMobileViewport ? 76 : 240"
            align="center"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <responsive-actions
                :items="getUserRowActions(row)"
                @select="handleUserRowAction($event, row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <mobile-record-list
          v-else
          :rows="list"
          :loading="loading"
          :title="getMobileChannelUserTitle"
          :subtitle="getMobileChannelUserSubtitle"
          :fields="mobileChannelUserFields"
          :actions="getUserRowActions"
          @action="handleUserRowAction"
        />
      </template>
    </tableComponents>

    <user-trigger-rules ref="userTriggerRef"></user-trigger-rules>
    <user-ad-list ref="userAdRef"></user-ad-list>
    <user-ad-log-list ref="userAdLogRef"></user-ad-log-list>
  </div>
</template>

<script>
import UserTriggerRules from "@/comment/userTriggerRules.vue";
import UserAdList from "@/comment/userAdList.vue";
import UserAdLogList from "@/comment/userAdLogList.vue";
import responsiveMixin from "@/mixins/responsive";

export default {
  mixins: [responsiveMixin],
  components: {
    UserTriggerRules,
    UserAdList,
    UserAdLogList,
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      queryForm: {},
      paginationForm: {
        page: 1,
        page_size: 15,
      },
    };
  },
  computed: {
    mobileChannelUserFields() {
      return [
        {
          label: "APP",
          value: (row) => (row.app && row.app.app_name) || "--",
        },
        { label: "渠道ID", key: "channel_id" },
        { label: "今日广告", value: (row) => row.ad_list || 0 },
        { label: "今日收益", value: (row) => row.ecpm_total },
        { label: "用户ID", key: "id", summary: false },
        { label: "账号", key: "username", summary: false },
        {
          label: "状态",
          value: (row) =>
            row.banned_time && row.banned_time * 1000 > Date.now()
              ? `封禁至 ${this.$fnc.getTimeFormat(row.banned_time, "ymdhms")}`
              : "正常",
          tag: true,
          tagType: (row) =>
            row.banned_time && row.banned_time * 1000 > Date.now()
              ? "danger"
              : "success",
          summary: false,
        },
        {
          label: "注册时间",
          value: (row) => this.$fnc.getTimeFormat(row.created_time, "ymdhms"),
          summary: false,
        },
      ];
    },
    userSearchData() {
      return () => [
        {
          title: "",
          type: "1",
          data: [
            {
              type: "date",
              arr: [],
              key: ["start_time", "end_time"],
              placeholder: "注册时间",
            },
          ],
        },
        {
          title: "",
          type: "2",
          data: [
            { type: "text", key: "nickname", placeholder: "搜索昵称" },
            { type: "text", key: "username", placeholder: "搜索账号" },
            { type: "text", key: "id", placeholder: "搜索用户ID" },
            { type: "text", key: "channel_id", placeholder: "搜索渠道ID" },
            {
              type: "select",
              key: "app_id",
              option: this.$store.getters.getAppListGetter,
              placeholder: "所属APP",
              onChange: () => {},
            },
          ],
        },
      ];
    },
  },
  methods: {
    getMobileChannelUserTitle(row) {
      return row.nickname || row.username || `用户 #${row.id}`;
    },
    getMobileChannelUserSubtitle(row) {
      return `用户ID ${row.id}`;
    },
    getUserRowActions(row) {
      return [
        { key: "trigger", label: "封控记录", type: "danger" },
        { key: "ad", label: "广告记录", type: "primary" },
        { key: "adlog", label: "其他广告", type: "info" },
        {
          key: "ban",
          label:
            row.banned_time && row.banned_time * 1000 > Date.now()
              ? "解除封禁"
              : "封禁",
          type: "warning",
        },
      ];
    },
    handleUserRowAction(command, row) {
      const handlers = {
        trigger: () => this.openDialog(row.id, "userTriggerRef"),
        ad: () => this.openDialog(row.id, "userAdRef"),
        adlog: () => this.openDialog(row.id, "userAdLogRef"),
        ban: () => this.toggleBan(row),
      };
      if (handlers[command]) {
        handlers[command]();
      }
    },
    async getUserList() {
      this.loading = true;
      try {
        const data = await this.$api.getChannel.getChannelUserList({
          ...this.paginationForm,
          ...this.queryForm,
        });
        this.total = data.data.count || 0;
        this.list = data.data.list || [];
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(page) {
      this.paginationForm.page = page;
      this.getUserList();
    },
    handleSizeChange(size) {
      this.paginationForm.page_size = size;
      this.getUserList();
    },
    getSearch(form) {
      this.queryForm = form;
      this.paginationForm.page = 1;
      this.getUserList();
    },
    openDialog(userId, key) {
      this.$refs[key].openDialog(userId);
    },
    toggleBan(row) {
      const active = row.banned_time && row.banned_time * 1000 > Date.now();
      if (active) {
        this.$confirm("确认解除该渠道用户封禁吗？", "提示", {
          type: "warning",
        }).then(async () => {
          const data = await this.$api.getUser.postBannedUser({
            user_id: row.id,
            time: 0,
          });
          if (data.code === 200) {
            this.$message.success("已解除封禁");
            this.getUserList();
          }
        });
        return;
      }

      this.$prompt("请输入封禁时长（秒）", "封禁渠道用户", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d+$/,
        inputErrorMessage: "请输入正整数秒数",
      }).then(async ({ value }) => {
        const data = await this.$api.getUser.postBannedUser({
          user_id: row.id,
          time: value,
        });
        if (data.code === 200) {
          this.$message.success("封禁成功");
          this.getUserList();
        }
      });
    },
  },
  created() {
    this.getUserList();
  },
};
</script>
